import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit, faSync, faPlus } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import Swal from 'sweetalert2';
import './CategoriasGastosData.css';
import baseURL from '../../url';

export default function CategoriasGastosData() {
    const [categorias, setCategorias] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [categoriaActual, setCategoriaActual] = useState({});
    const [nombre, setNombre] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [filtro, setFiltro] = useState('');

    useEffect(() => {
        cargarCategorias();
    }, []);

    const cargarCategorias = () => {
        fetch(`${baseURL}/categoriasGastosGet.php`)
            .then(response => response.json())
            .then(data => setCategorias(data.categorias || []))
            .catch(error => console.error('Error:', error));
    };

    const abrirModalNuevo = () => {
        setCategoriaActual({});
        setNombre('');
        setDescripcion('');
        setModalVisible(true);
    };

    const abrirModalEditar = (categoria) => {
        setCategoriaActual(categoria);
        setNombre(categoria.nombre);
        setDescripcion(categoria.descripcion || '');
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
        setNombre('');
        setDescripcion('');
    };

    const guardarCategoria = () => {
        if (!nombre) {
            toast.error('El nombre es obligatorio');
            return;
        }

        if (categoriaActual.idCategoriaGasto) {
            // Editar
            const payload = { nombre, descripcion };
            fetch(`${baseURL}/categoriasGastosPut.php?idCategoriaGasto=${categoriaActual.idCategoriaGasto}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            })
                .then(response => response.json())
                .then(data => {
                    if (data.error) {
                        toast.error(data.error);
                    } else {
                        Swal.fire('¡Actualizado!', data.mensaje, 'success');
                        cargarCategorias();
                        cerrarModal();
                    }
                })
                .catch(error => toast.error(error.message));
        } else {
            // Crear
            const formData = new FormData();
            formData.append('nombre', nombre);
            formData.append('descripcion', descripcion);

            fetch(`${baseURL}/categoriasGastosPost.php`, {
                method: 'POST',
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    if (data.error) {
                        toast.error(data.error);
                    } else {
                        Swal.fire('¡Creado!', data.mensaje, 'success');
                        cargarCategorias();
                        cerrarModal();
                    }
                })
                .catch(error => toast.error(error.message));
        }
    };

    const eliminarCategoria = (idCategoriaGasto) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#D83098',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                fetch(`${baseURL}/categoriasGastosDelete.php?idCategoriaGasto=${idCategoriaGasto}`, {
                    method: 'DELETE'
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.error) {
                            Swal.fire('Error', data.error, 'error');
                        } else {
                            Swal.fire('¡Eliminado!', data.mensaje, 'success');
                            cargarCategorias();
                        }
                    })
                    .catch(error => toast.error(error.message));
            }
        });
    };

    const categoriasFiltradas = categorias.filter(item =>
        item.nombre.toLowerCase().includes(filtro.toLowerCase())
    );

    return (
        <div>
            <ToastContainer />

            <div className='deFlexContent'>
                <button className='btnPost' onClick={abrirModalNuevo}>
                    <FontAwesomeIcon icon={faPlus} /> Agregar Categoría
                </button>

                <div className='filtrosContain' style={{justifyContent: 'flex-end' }}>
                    <input
                        type="text"
                        placeholder="Buscar categoría"
                        value={filtro}
                        onChange={(e) => setFiltro(e.target.value)}
                        className='filtroInput'
                    />
                    
                </div>
            </div>

            {modalVisible && (
                <div className="modal">
                    <div className="modal-content">
                        <div className='deFlexBtnsModal'>
                            <h3>{categoriaActual.idCategoriaGasto ? 'Editar Categoría' : 'Nueva Categoría'}</h3>
                            <span className="close" onClick={cerrarModal}>&times;</span>
                        </div>

                        <fieldset>
                            <legend>Nombre de la categoría</legend>
                            <input 
                                type="text" 
                                value={nombre} 
                                onChange={(e) => setNombre(e.target.value)} 
                                placeholder="Ej: Servicios, Compras, Mantenimiento..."
                            />
                        </fieldset>

                        <fieldset>
                            <legend>Descripción (opcional)</legend>
                            <textarea
                                value={descripcion}
                                onChange={(e) => setDescripcion(e.target.value)}
                                rows="3"
                                placeholder="Descripción de la categoría..."
                            />
                        </fieldset>

                        <button className='btnPost' onClick={guardarCategoria}>Guardar</button>
                    </div>
                </div>
            )}

            <div className='table-container'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre de la Categoría</th>
                            <th>Descripción</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {categoriasFiltradas.length > 0 ? (
                            categoriasFiltradas.map(item => (
                                <tr key={item.idCategoriaGasto}>
                                    <td>{item.idCategoriaGasto}</td>
                                    <td>{item.nombre}</td>
                                    <td>{item.descripcion || '-'}</td>
                                    <td>
                                        <button className='editar' onClick={() => abrirModalEditar(item)}>
                                            <FontAwesomeIcon icon={faEdit} />
                                        </button>
                                        <button className='eliminar' onClick={() => eliminarCategoria(item.idCategoriaGasto)}>
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4" style={{ textAlign: 'center', padding: '2rem' }}>
                                    No hay categorías registradas
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}






